module.exports = __webpack_public_path__ + "img/voucher.b0ce2d1e.png";